<script lang="ts">
  import Alert from '$shared/atoms/Alert/Alert.svelte';
  import { AlertOption } from '$provider/models/AlertOption';
  import type { AlertDetailedInfo } from '$shared/models/AlertDetailedInfo';

  interface Props {
    error?: AlertDetailedInfo | string | null | undefined;
    errorReasons?: string[];
    name?: string;
    onalertclose?: () => void;
    onsubmit?: (e: SubmitEvent) => void;
    children?: import('svelte').Snippet;
  }

  let {
    error = '',
    errorReasons = [],
    name = '',
    onalertclose,
    onsubmit,
    children
  }: Props = $props();

  const onAlertClose = () => {
    onalertclose?.();
  };
</script>

<form data-cy={`${name}-form`} class="comp-form" {onsubmit}>
  {#if error}
    <div class="alert">
      <Alert
        maxWidth
        closable
        data={error}
        options={AlertOption.errorAlertWithReason(errorReasons)}
        onclose={onAlertClose}
      />
    </div>
  {/if}
  {@render children?.()}
</form>

<style>
  .comp-form {
    display: flex;
    flex-direction: column;
  }
  .alert {
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
